import {Figure} from "react-bootstrap";
import React from "react";
import {Link} from "react-router-dom";
import {useTipList} from "../../backend2/admin/tip/useTip";
import {useWindowSize} from "../../../hooks";
import {OurClearAlert, ProductCardLoading} from "../../_components";
import {useDarkMode} from "../../../context";
import {config, extractGitHubPath} from "../../../utils2";

export function TipsCard() {
    const {list, loadingList, errorList, clearErrorList} = useTipList()

    return (<div className="d-flex justify-content-evenly flex-wrap gap-2">

            <OurClearAlert variant="danger" msg={errorList} onClear={clearErrorList}/>

            <ProductCardLoading show={loadingList}/>

            {list && list.length > 0 ? (
                list.map((item, index) => (
                    <div key={index} className="col-12 col-sm-5 col-md-4 col-lg-3 col-xl-2">
                        <RenderTip item={item}/>
                    </div>
                ))
            ) : (
                <p>No tip available.</p>
            )}
        </div>
    )
}

function RenderTip({item}) {
    const {width} = useWindowSize()
    const {darkMode} = useDarkMode()

    const extractedPath = extractGitHubPath(item?.url);
    const goToUrl = extractedPath ? `/git/${extractedPath}` : item.url;

    const cardWidth = width < 576 ? "100%" : "260px"
    const cardHeight = width < 576 ? "100%" : "400px"
    return <div>

        <div
            className="card border-0 bg-light-subtle"
            style={{width: cardWidth, height: cardHeight, overflow: 'hidden'}}
        >

            <Figure className="d-flex justify-content-center">
                <Link to={item.url}>
                    <Figure.Image
                        src={config.get_public_media(item.media_first_path, "medium", darkMode)}
                        alt={item.title}
                        rounded
                        height="150px"
                        width="150px"
                        loading="lazy"
                    />
                </Link>
            </Figure>

            <Link to={goToUrl}
                  className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                <span className="text-wrap fw-bolder">{item.title}</span>
            </Link>

            <div className="text-wrap">
                {item.description}
            </div>

        </div>

    </div>
}